import { v4 as uuidv4 } from 'uuid';

const BFF_BASE_URL = process.env.REACT_APP_BFF_BASE_URL

export async function saveAnalytics(data: any, session: any) {
    const headers: any = {
        'Content-Type': 'application/json',
        'x-correlation-id': uuidv4(),
        'x-session-id': session?.sessionId || 'x-session-id'
    }
    if(session?.idToken && ((session?.expiryMs || 0) > Date.now())) {
        headers['Authorization']= `Bearer ${session?.accessToken}`;
        headers['x-id']= `${session?.idToken}`;
    }
    try {
        await fetch(`${BFF_BASE_URL}/v1/analytics`,
            {
                method: 'POST',
                body: JSON.stringify(data),
                headers
            }
        );    
    } catch {
        console.log('BFF API Service not available')
    }
    
}